module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_slotman_sm-2dbe9d073b6b4007470bee8b3bebd8a3.png";